import { ModalContent as NextUIModalContent, ModalContentProps as NextUIModalContentProps } from "@heroui/react";

export interface ModalContentProps extends NextUIModalContentProps {}
export const ModalContent = ({children, ...props}: ModalContentProps) => {
  return (
    <NextUIModalContent {...props}>
      {children}
    </NextUIModalContent>
  )
}